export default __webpack_public_path__ + "static/media/otherskillsicon.06766001.svg";